import { render } from "./RestaurantMenuItemsView.vue?vue&type=template&id=1ffbc310&scoped=true"
import script from "./RestaurantMenuItemsView.vue?vue&type=script&lang=js"
export * from "./RestaurantMenuItemsView.vue?vue&type=script&lang=js"

import "./RestaurantMenuItemsView.vue?vue&type=style&index=0&id=1ffbc310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffbc310"]])

export default __exports__